import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ComparisonService } from '@comparison/feature';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sd-product-comparison-button',
  templateUrl: './product-comparison-button.component.html',
  styleUrls: ['./product-comparison-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, SdvorIconComponent],
})
export class SdvorProductComparisonButtonComponent implements OnInit {
  hasEntry$: Observable<boolean>;
  loading$: Observable<boolean>;
  @Input() productCode: string;

  constructor(private comparisonService: ComparisonService) {}

  ngOnInit(): void {
    this.hasEntry$ = this.comparisonService.hasEntry(this.productCode);
    this.loading$ = this.comparisonService.getEntryLoading(this.productCode);
  }

  addOrRemoveEntry(): void {
    this.hasEntry$.pipe(take(1)).subscribe((hasEntry) => {
      if (hasEntry) {
        this.comparisonService.removeEntry(this.productCode);
      } else {
        this.comparisonService.addEntry(this.productCode);
      }
    });
  }
}
